import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";

//import Badge from '@material-ui/core/Badge';
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
//import NotificationsIcon from '@mui/icons-material/Notifications';
import ListItems from "./listItems";

//import size dimensions
import useWindowDimensions from "./WindowDimensions";

import canaaBandeira from "../../assets/LogoFalaCanaa.png";
import { AreaLogo, Area } from "./styles";
import Header from "../../components/Header";
import ActiveUsers from "../UsersActive";
import UserPermission from "../UserPermission";
export const drawerWidth = 296;

const useStyles = makeStyles((theme, lagura) => ({
  root: {
    display: "flex",
  },

  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },

  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },

  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    backgroundColor: "#FFFFFF",
  },

  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px + ${lagura}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },

  menuButton: {
    marginRight: 0,
    color: "#2F5CA1",
  },

  menuButtonHidden: {
    display: "none",
  },

  title: {
    flexGrow: 1,
  },

  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    backgroundColor: "#F5F5F5",
    width: theme.spacing(37),
  },

  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },

  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: "100vh",
    overflow: "auto",
    backgroundColor: "white",
  },

  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },

  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },

  fixedHeight: {
    height: 240,
  },
}));

export default function Sidebar({ children }) {
  const userPermisson = UserPermission();
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [windowWidth, setWindowWidth] = useState("");
  const [menu, setMenu] = useState("temporary");

  // seta tamanho da janela
  const { width } = useWindowDimensions();

  useEffect(() => {
    setWindowWidth(width);
    // seta o tamanho menor que 750 para renderizar fechado
    if (width < 750) {
      setOpen(false);
      setMenu("temporary");
    } else {
      setOpen(true);
      setMenu("permanent");
    }
  }, [width]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(classes.appBar, open && classes.appBarShift)}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            className={clsx(
              classes.menuButton,
              open && classes.menuButtonHidden
            )}
            style={{ opacity: windowWidth > 750 ? 0.0 : 1, height: "100%" }}
            disabled={windowWidth > 750}
          >
            <MenuIcon
              style={{ height: "1.3em", width: "1.3em", color: "#2F5CA1" }}
            />
          </IconButton>

          <Typography
            component="h1"
            variant="h6"
            color="inherit"
            noWrap
            className={classes.title}
            style={{ margin: -18 }}
          >
            <Area style={{ display: windowWidth < 750 ? "none" : "block" }}>
              <AreaLogo>
                <div>
                  <a
                    href="https://www.canaadoscarajas.pa.gov.br/novo/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <img
                      src={canaaBandeira}
                      className="bandeira"
                      alt="Logo UFPA"
                    />
                  </a>
                </div>
              </AreaLogo>
            </Area>
          </Typography>
          <Header />
        </Toolbar>
      </AppBar>
      <Drawer
        id="sidebar"
        variant={menu}
        classes={{
          paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
        }}
        open={open}
        style={{ opacity: open === false ? 0.0 : 1 }}
      >
        <div className={classes.toolbarIcon}>
          <div style={{ padding: 8, width: 60 }}>
            <a
              href="https://www.canaadoscarajas.pa.gov.br/novo/"
              rel="noreferrer"
              target="_blank"
            >
              <img
                src={canaaBandeira}
                style={{ width: 60 }}
                className="bandeira"
                alt="Logo UFPA"
              />
            </a>
          </div>

          <IconButton
            onClick={handleDrawerClose}
            disabled={windowWidth > 750}
            style={{ opacity: windowWidth > 750 ? 0.0 : 1 }}
          >
            <ChevronLeftIcon />
          </IconButton>
        </div>

        <Divider />
        <List>
          <ListItems closeSidebarIfMobile={() => setOpen(windowWidth > 750)} />
        </List>

        {/* Traça uma linha divisória */}
        {/*<Divider />*/}
        {/*<List>{secondaryListItems}</List>*/}
      </Drawer>
      <main
        className={classes.content}
        style={{ paddingTop: windowWidth > 750 ? 0 : 30 }}
      >
        <div className={classes.appBarSpacer} />
        {children}
      </main>

      {userPermisson === "admin" && <ActiveUsers />}
    </div>
  );
}
